function processAdapterConfig(adapter, config) {
    const statics = {};
    if (typeof config === "function") {
        config = config(adapter.props);
    }
    if (! (config instanceof Array)) { // an Object w/ keys as props
        const ca = [];
        for (const k in config) {
            if (config.hasOwnProperty(k)) {
                const c = config[k];
                if (c.hasOwnProperty("prop")) {
                    console.warn(`The bind config for prop '${k}' has an explicit \`prop\` attribute (${c.prop}).`);
                }
                if (typeof c === "function") {
                    statics[k] = c;
                } else {
                    ca.push(Object.assign({prop: k, attribute: k}, c));
                }
            }
        }
        config = ca;
    }
    const items = config.map(it => {
        const c = Object.assign({}, it);
        if (!c.hasOwnProperty("event")) {
            c.event = `change:${c.attribute}`;
        }
        if (!c.hasOwnProperty("func")) {
            if (!c.hasOwnProperty("prop")) {
                c.prop = c.attribute;
            }
            if (c.hasOwnProperty("value")) {
                c.func = () => ({[c.prop]: c.value});
            } else if (c.hasOwnProperty("get")) {
                c.func = function() {
                    return {[c.prop]: c.get(...arguments)};
                };
            } else {
                c.func = model => {
                    let result;
                    if (c.hasOwnProperty("errorValue")) {
                        try {
                            result = model.get(c.attribute);
                        } catch (e) {
                            result = c.errorValue;
                        }
                    } else {
                        result = model.get(c.attribute);
                    }
                    return {[c.prop]: result};
                };
            }
        }

        c.listenerFunc = function() {
            adapter.setState(() => c.func(...arguments));
        };
        return c;
    });
    items.statics = statics;
    return items;
}

export default processAdapterConfig;



// WEBPACK FOOTER //
// ./app/lib/common/hoc/BackboneReact/processAdapterConfig.js